<template>
  <!-- <div class="footer" v-if="thirdType == 1"> -->
  <div class="footer">
    <van-divider class="divider">第三方登录方式</van-divider>
    <div class="attestation">广东省统一身份认证</div>
    <div class="icon-list">
      <img src="@/assets/img/common/wechat.png">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.footer {
  text-align: center;
  width: 100%;
  padding: 25px 0;
  background-color: #fff;
  .divider {
    font-size: 12px;
    width: 70%;
    margin: 0 auto;
  }
  .attestation {
    font-size: 14px;
    font-weight: 500;
    color: #1d84ff;
    padding-top: 10px;
  }
  .icon-list {
    padding-top: 10px;
    img {
      width: 30px;
      & + img {
        margin-left: 10px;
      }
    }
  }
}
</style>